import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import BackboneValidation from 'backbone-validation';
import Global from 'models/Global';
import Auth from 'models/Auth';
import FormViewMixin from 'views/FormViewMixin';
import EditProfileImageView from 'views/EditProfileImageView';
import signUpTemplate from 'hbars!templates/signUp';
import signUpStep2Template from 'hbars!templates/signUpStep2';

var SignUpView = Backbone.View.extend({
    shouldShowStepIndicator: true,

    events: {
        'change input[name="agreeTOS"]': 'renderNextButton',
        'click .submit-button': 'nextClicked',
        'click .the-next-step': 'showNextStep',
        'click .button-import-linkedin': 'importLinkedinInfo'
    },

    initialize: function(options) {
        options = options || {};
        this.auth = new Auth();
        this.model = this.model || Global.get('me');
        this.event = options.event || Global.get('event');
        this.isVerified = false;
        this.listenTo(this.auth, 'change:isLoading', this.setLoading);
        this.listenTo(this.model, 'change:isLoading', this.setLoading);
        this.listenTo(this.model, 'change:photoUrl', this.renderPhoto);
        this.listenTo(this.model, 'validated', this.renderNextButton);
        this.initValidation({
            attrs: ['firstName', 'lastName', 'primaryEmail', 'password', 'title', 'company', 'country'],
            enhance: {
                icheck: false
            },
            tracking: false
        });

        Backbone.trigger('analytics:OneMoreStep');
    },

    signUpSuccess: function(data) {
        this.model.set(this.model.parse(data));

        this.showNextStep();
    },

    signUpError: function(errorCode) {
        var EmailAlreadyExistsError = 4092;
        var TokenMismatchError = 4031;
        var text;
        if (errorCode == EmailAlreadyExistsError) {
            text = 'This Email is associated with another Bizzabo account. Please use the Login with Email / Password option.';
        } else if (errorCode == TokenMismatchError) {
            text = 'Linkedin account is associated with another Bizzabo account. Please use the Login with Linkedin option.';
        } else {
            text = 'Sign up error: ' + errorCode;
        }
        this.$('.login-error-wrapper').text(text);
        this.$('.login-error-wrapper').addClass('appear');
    },

    setLoading: function() {
        var loading = this.auth.get('isLoading');
        this.$('.loading').toggleClass('hide', !loading);
        this.$('.submit-button').toggle(!loading);
    },

    nextClicked: function() {
        var checked = this.$('input[name="agreeTOS"]').is(':checked');
        var isValid = checked && this.model.isValid(true);
        if (!isValid) {
            return;
        }
        this.showNextStep();
    },

    showNextStep: function() {
        var nextView = new SignUpStep2View({
            model: this.model,
            event: this.event
        });
        this.trigger('next', nextView);
    },

    renderNextButton: function() {
        var checked = this.$('input[name="agreeTOS"]').is(':checked');
        var isValid = checked && this.model.isValid();
        this.$('.submit-button').toggleClass('disabled', !isValid);
    },

    renderPhoto: function() {
        var value = this.model.get('photoUrl');
        var imageElement = this.$('[name="photoUrl"]');
        imageElement.attr('src', value).toggleClass('hide', !value);
    },

    render: function() {
        var html = signUpTemplate(_.extend(this.model.toJSON()), {isVerified: this.isVerified});
        this.$el.html(html);
        this.renderNextButton();
        this.renderForm();

        new EditProfileImageView({
            model: this.model,
            imageProperty: 'photoUrl',
            parentView: this,
            el: this.$('.profile-img')
        });

        return this;
    },

    linkedInErrorLogic: function(error) {
        const me = this.model;
        me.unset('linkedInId');
        let message = error && error.message;
        if (!message) {
            message = 'Error connecting with Linkedin';
            var TokenMismatchError = 4031;
            if (error == TokenMismatchError) {
                message = 'Linkedin account binded to another user';
            } else {
                message = 'Error connecting with Linkedin';
            }
        }
        this.showLinkedinErrorMessage(message);
    },

    showLinkedinErrorMessage: function(message) {
        const _message = message || 'There was a problem getting your profile data from linkedin';
        this.$('.error-linkedin').text(_message);
        this.$('.error-linkedin').addClass('error-visible');
        setTimeout(this.hideLinkedinErrorMessage, 3000);
    },
    hideLinkedinErrorMessage: function() {
        this.$('.error-linkedin').text('');
        this.$('.error-linkedin').removeClass('error-visible');
    },
    importLinkedinInfo: function() {
        this.hideLinkedinErrorMessage();
        const me = this.model;
        let auth = new Auth();
        const error = this.linkedInErrorLogic.bind(this);
        const success = (data) => {
            me.setLinkedinData(data);
        };
        auth.connectWithLinkedin({error, success});
    }
});
_.extend(SignUpView.prototype, FormViewMixin);


var SignUpStep2View = Backbone.View.extend({
    shouldShowStepIndicator: true,

    events: {
        'click .next-button': 'nextClicked'
    },

    initialize: function(options) {
        options = options || {};
        this.model = this.model || Global.get('me');
        this.event = options.event || Global.get('event');
        this.listenTo(this.model, 'validated', this.renderNextButton);
        this.initValidation({
            attrs: ['oneLiner', 'web', 'blog', 'summary'],
            tracking: false
        });
        Backbone.trigger('analytics:OneMoreStep2');
    },

    nextClicked: function() {
        var thisView = this;
        var isValid = this.model.isValid(true);
        isValid && this.model.save({}, {
            success: function() {
                thisView.joinEvent();
            },
            error: function(model, data) {
                var errorCode = (data.error && data.error['error-code']) || 0;
            }

        });
    },

    joinEvent: function() {
        this.model.set('joinedNow', true);
        if (!this.model.noJoin) {
            this.model.join(this.event.id);
        } else {
            this.model.set({isJoined: true});
        }
    },

    joinError: function(errorCode) {
        var NeedAdditionalAuth = 4014;
        if (errorCode == NeedAdditionalAuth) {
            this.trigger('private-community');
        }
    },

    renderNextButton: function() {
        var isValid = this.model.isValid();
        this.$('.next-button').toggleClass('disabled', !isValid);
    },

    render: function() {
        var html = signUpStep2Template(this.model.toJSON());
        this.$el.html(html);
        this.renderNextButton();
        this.renderForm();
        return this;
    }

});
_.extend(SignUpStep2View.prototype, FormViewMixin);

export default SignUpView;


